import { cn } from "@/utils/ui";
import { type FileRouteTypes, Link, useMatches } from "@tanstack/react-router";
import { type MouseEvent, type MouseEventHandler, useCallback } from "react";
import toast from "react-hot-toast";

interface NavigationItem {
  title: string;
  href: FileRouteTypes["to"];
  tags?: "wip"[];
}

const navigationItems: NavigationItem[] = [
  {
    title: "展馆",
    href: "/",
  },
  {
    title: "活动",
    href: "",
    tags: ["wip"],
  },
  {
    title: "博客",
    href: "",
    tags: ["wip"],
  },
  {
    title: "色板",
    href: "",
    tags: ["wip"],
  },
  {
    title: "圈子",
    href: "",
    tags: ["wip"],
  },
  {
    title: "市场",
    href: "",
    tags: ["wip"],
  },
];

type EvalutedNavigationItem = {
  item: NavigationItem;
  active: boolean;
  onClick: MouseEventHandler<HTMLAnchorElement>;
};

export function Navigation({ className }: { className?: string }) {
  const defaultOnClick = useCallback(
    (_e: MouseEvent<HTMLAnchorElement>) => {},
    [],
  );
  const wipOnClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    toast("该功能正在开发中，敬请期待！");
  }, []);

  const matchedRoutes = useMatches();

  const evaluatedItems: EvalutedNavigationItem[] = navigationItems.map(
    (item) => ({
      item,
      active: matchedRoutes.some((route) => route.id === item.href),
      onClick: item.tags?.includes("wip") ? wipOnClick : defaultOnClick,
    }),
  );

  return (
    <nav className={cn("hidden space-x-8 sm:flex", className)}>
      {evaluatedItems.map(({ item, active, onClick }) => (
        <Link
          key={item.title}
          to={item.href}
          className={cn(
            "text-sm inline-flex items-center font-pixel",
            active
              ? "text-gray-fg-primary"
              : "text-gray-fg-secondary hover:text-gray-fg-primary",
          )}
          onClick={onClick}
        >
          {item.title}
        </Link>
      ))}
    </nav>
  );
}
